const middleware = {}

middleware['checkCart'] = require('../../../middleware/checkCart.js')
middleware['checkCart'] = middleware['checkCart'].default || middleware['checkCart']

middleware['checkPayment'] = require('../../../middleware/checkPayment.js')
middleware['checkPayment'] = middleware['checkPayment'].default || middleware['checkPayment']

middleware['fetchUnidade'] = require('../../../middleware/fetchUnidade.js')
middleware['fetchUnidade'] = middleware['fetchUnidade'].default || middleware['fetchUnidade']

export default middleware
